export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const SET_IS_UPLOADING = 'SET_IS_UPLOADING';
export const ADD_STAGED_FILE = 'ADD_STAGED_FILE';
export const REMOVE_STAGED_FILE = 'REMOVE_STAGED_FILE';
export const RESET_FILE_UPLOADER = 'RESET_FILE_UPLOADER';
export const ADD_SELECTED_FILE = 'ADD_SELECTED_FILE';
export const REMOVE_SELECTED_FILE = 'REMOVE_SELECTED_FILE';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/file-uploader/constants.es6